<!-- src/App.vue -->
<template>
	<LoadingView v-if="store.isLoading" :title="store.loadingTitle" :message="store.loadingMessage" />

	<div v-else class="app">
		<Header />
		<main v-if="store.timeStatus" class="main-content">
			<div class="router-view-container">
				<RouterView />
			</div>
		</main>
	</div>

	<AlertModal ref="alertModalRef" />
</template>

<script setup>
import { ref, onMounted, watch, nextTick } from 'vue'
import { useLiff } from '@/composables/useLiff'
import { RouterView, useRouter, useRoute } from 'vue-router'
import { useStore } from '@/stores/index.js'
import Header from '@/components/Header.vue'
import LoadingView from '@/components/LoadingView.vue'
import AlertModal from '@/components/common/AlertModal.vue'

const { initLiff } = useLiff()
const store = useStore()
const alertModalRef = ref(null)
const router = useRouter()
const route = useRoute()

onMounted(async () => {
	try {
		store.setAlertRef(alertModalRef.value)
		if (import.meta.env.VITE_isInClient === 'true') {
			//env 解析出來的都是字串 不是布林值
			// 測試環境
			console.log('進測試環境')
			store.resetAll()
			store.setTimeStatus(true)
		} else {
			// 正式環境 要做liff
			store.resetAll()
			await initLiff()
			// store.setTimeStatus(true)
		}
	} catch (err) {
		console.error('❌ 初始化失敗:', err)
	} finally {
		// stopLoading 統一在這裡，確保一定執行
		store.stopLoading()
		// 等 Vue 把 main content 渲染進 DOM，再移除 html-loader
		// 避免 html-loader 消失後有短暫空白
		await nextTick()
		document.getElementById('html-loader')?.remove()
	}
})
</script>

<style scoped>
/* App 外層固定高度 */
.app {
	display: flex;
	flex-direction: column;
	height: 100vh;
	/* border-radius: 30px; */
	position: relative;
	z-index: 0;
}

/* main 整體可捲動區塊（含 RouterView + Footer） */
.main-content {
	background: #fff;
	flex: 1;
	overflow-x: hidden;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;

	display: flex;
	flex-direction: column;

	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
}

/* 原本 main-content 的內容樣式給 RouterView 用 */
.router-view-container {
	flex: 1;
	display: flex;
	flex-direction: column;
}
</style>
